export default "__VITE_ASSET__l4w2o12N__"